import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { CancelSubscription } from '../components/CancelSubscription/CancelSubscription';
import { selectors, actions, operations } from '../ducks/subscriptions';
import type { Props as CancelSubscriptionProps } from '../components/CancelSubscription/CancelSubscription';

type ChildrenProps = CancelSubscriptionProps;
export type Props = ChildrenProps;

const mapStateToProps = (state) => {
  const subscriptions = selectors.getActiveSubscriptionsSelector(state);
  const usageSubscriptions = selectors.getUsageSubscriptionsSelector(state) || List();
  const concurrencySubscriptions = selectors.geConcurrencySubscriptionsSelector(state) || List();
  return {
    subscriptions,
    usageSubscriptions,
    concurrencySubscriptions,
  };
};

const mapDispatchToProps = {
  cancelSubscriptions: operations.cancelSubscriptions,
  showModal: modalActions.showModal,
  fetchSubscriptions: actions.fetchSubscriptions,
};

export const CancelSubscriptionsContainer: React.FC<Props> = (props) => (
  <CancelSubscription
    {...props}
    subscriptions={props.subscriptions}
  />
);

export default connect<ChildrenProps>(mapStateToProps, mapDispatchToProps)(
  CancelSubscriptionsContainer,
);
